import axios from "axios";

//const baseUrl = 'http://crm.gard';
const baseUrl = 'https://crm.gardennumberone.com';

export default class ProductService {
    static async getAll(data) {
        try {
            const response = await axios.post(baseUrl+'/api/products', data);
            return response.data.data;
        } catch (err) {
            console.log(err);
        }
    }



    static async getOne(id) {
        try {
            const response = await axios.get(baseUrl+'/api/product/'+id);
            return response.data;
        } catch (err) {
            console.log(err);
        }
    }
    static async create(porductData) {
        try {
            const response = await axios.post(baseUrl+'/api/product/create', porductData);
            return response;
        } catch (err) {
            return(err.response);
        }
    }
    static async edit(porductData) {
        try {
            const response = await axios.post(baseUrl+'/api/product/edit', porductData);
            return response;
        } catch (err) {
            return(err.response);
        }
    }
}
